// LoadingSpinner.js
import React from "react";
import { TailSpin } from "react-loader-spinner";

const LoadingSpinner = () => {
  return (
    <div className="loading-spinner">
      <TailSpin height="60" width="60" color="#000" ariaLabel="loading" />
    </div>
  );
};

export default LoadingSpinner;
